import liveServices from 'interview/services/live'
import { httpError } from 'actions/http'

export const LIVE_INTERVIEW_RECEIVE = 'LIVE_INTERVIEW_RECEIVE'
export const LIVE_INTERVIEW_CREATE_CALENDAR_EVENT =
  'LIVE_INTERVIEW_CREATE_CALENDAR_EVENT'

export const receiveLiveInterview = payload => ({ type: LIVE_INTERVIEW_RECEIVE, payload })

export const createCalendarEventRequest = () => ({ type: LIVE_INTERVIEW_CREATE_CALENDAR_EVENT })

export const fetchLiveInterview = (liveInterviewId, roomCode) => dispatch =>
  liveServices
    .fetchLive(liveInterviewId, roomCode)
    .then(liveInterview => {
      dispatch(receiveLiveInterview(liveInterview))
    })
    .catch(err => {
      if (
        err.response && (err.response.status === 404 || err.response.status === 403)
      ) {
        dispatch(httpError(err.response.status))
      } else {
        throw err
      }
    })

export const fetchLiveInterviewSchedulingData =
  (liveInterviewId, roomCode) => dispatch => {
    return liveServices
      .fetchScheduledLiveData(liveInterviewId, roomCode)
      .then(liveInterview => {
        dispatch(receiveLiveInterview(liveInterview))
      })
      .catch(err => {
        if (
          err.response && (err.response.status === 404 || err.response.status === 403)
        ) {
          dispatch(httpError(err.response.status))
        } else {
          throw err
        }
      })
  }

export const createCalendarEventAndUpdateLive = (liveInterviewId, roomCode, slot) => dispatch => {
    dispatch(createCalendarEventRequest())
    liveServices
      .createCalendarEventAndUpdateLive(liveInterviewId, roomCode, slot)
      .then(liveInterview => {
        dispatch(receiveLiveInterview(liveInterview))
      })
      .catch(err => {
        if (
          err.response && (err.response.status === 404 || err.response.status === 403)
        ) {
          dispatch(httpError(err.response.status))
        } else {
          throw err
        }
      })
}
